import React from "react";
import PropTypes from "prop-types";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";
import ServiceData from "../data/service.json";
import ServiceDetailsContainer from "../containers/Products/products-details";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";

const ProductsDetails = ({
    match: {
        params: { id },
    },
}) => {
    // const serviceId = parseInt(id, 10);
    const serviceId = id;
    const data = ServiceData.filter((service) => service.url === serviceId);
    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title={
                        data[0]?.title +
                        " | NeoGrowth - Lending simplified. Growth amplified. "
                    }
                />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title={data[0]?.title}
                        excerpt={
                            "Product of <b class='b-color'>" +
                            data[0]?.type +
                            "</b>"
                        }
                        // image={data[0]?.image}
                    />
                    <ServiceDetailsContainer data={data[0]} />
                    {/* <NewsletterArea /> */}
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

ProductsDetails.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
};

export default ProductsDetails;
